import { useSubscriptionCompetitionsPrizesPageContext } from "../context";
import Skeleton from "react-loading-skeleton";
import React from "react";
import { useIsMobile } from "@/app/redux/features/device/selectors";

const Specs = () => {
  const { prizeStraplineTexts, isPrizeStraplineTextsLoading } = useSubscriptionCompetitionsPrizesPageContext();
  const isMobile = useIsMobile();

  if (isPrizeStraplineTextsLoading) {
    return (
      <Skeleton inline highlightColor="#fff" height={isMobile ? 32 : 35} containerClassName="w-full bg-[#f1f1f1]" />
    );
  }
  return (
    <div className={"gap-[11px] font-jost flex items-center lg:gap-8"}>
      {/*#1*/}
      <div className={"flex items-center gap-[3px] lg:gap-3"}>
        <img
          src={"/assets/images/subscription-competitions/botb-logo-icon.png"}
          alt={"cars-only"}
          width={32}
          height={32}
          className={"size-6 lg:size-8 shrink-0"}
        />
        <div className={"flex flex-col gap-1 lg:gap-1.5"}>
          <div className={"text-[#696971] text-xs font-bold leading-[14px] lg:text-sm lg:leading-5"}>
            <img
              src={"/assets/images/subscription-competitions/uk-flag-icon.png"}
              alt={"uk flag"}
              width={80}
              height={50}
              className={"w-5.5 shrink-0"}
            />
          </div>
          <div
            className={
              "text-[#696971] text-[11px] font-medium leading-[14px] lg:text-sm lg:font-normal lg:leading-[15px]"
            }>
            No. 1
          </div>
        </div>
      </div>

      <div className={"w-px h-[26px] bg-black/8 lg:hidden"} />

      {/*#2*/}
      <div className={"flex items-center gap-[3px] lg:gap-3"}>
        <img
          src={"/assets/images/subscription-competitions/est-icon.png"}
          alt={"cars-only"}
          width={32}
          height={32}
          className={"size-6 lg:size-8 shrink-0"}
        />
        <div className={"flex flex-col max-lg:gap-0.5"}>
          <div className={"text-[#696971] text-xs font-bold leading-[14px] lg:text-sm lg:leading-5"}>
            {prizeStraplineTexts.PrizeStraplineText1}yrs
          </div>
          <div
            className={
              "text-[#696971] text-[11px] font-medium leading-[14px] lg:text-sm lg:font-normal lg:leading-[15px]"
            }>
            of winners
          </div>
        </div>
      </div>

      {/*#3*/}
      <div className={"flex items-center gap-[3px] lg:gap-3"}>
        <img
          src={"/assets/images/subscription-competitions/prizes-won-icon.png"}
          alt={"cars-only"}
          width={32}
          height={32}
          className={"size-6 lg:size-8 shrink-0"}
        />
        <div className={"flex flex-col max-lg:gap-0.5"}>
          <div className={"text-[#696971] text-xs font-bold leading-[14px] lg:text-sm lg:leading-5"}>
            {prizeStraplineTexts.PrizeStraplineText2}
          </div>
          <div
            className={
              "text-[#696971] text-[11px] font-medium leading-[14px] lg:text-sm lg:font-normal lg:leading-[15px]"
            }>
            in Prizes Won
          </div>
        </div>
      </div>

      {/*#4*/}
      <div className={"flex items-center gap-[3px] lg:gap-3"}>
        <img
          src={"/assets/images/subscription-competitions/customers-icon.png"}
          alt={"cars-only"}
          width={32}
          height={32}
          className={"size-6 lg:size-8 shrink-0"}
        />
        <div className={"flex flex-col max-lg:gap-0.5"}>
          <div className={"text-[#696971] text-xs font-bold leading-[14px] lg:text-sm lg:leading-5"}>
            {prizeStraplineTexts.PrizeStraplineText3}
          </div>
          <div
            className={
              "text-[#696971] text-[11px] font-medium leading-[14px] lg:text-sm lg:font-normal lg:leading-[15px]"
            }>
            Winners
          </div>
        </div>
      </div>
    </div>
  );
};

export default Specs;
